import type { PlayerData } from '@/types';

interface PlayerInfoProps {
  player: PlayerData;
}

export const PlayerInfo = ({ player }: PlayerInfoProps) => {
  return (
    <div className="section">
      <div className="label">Informations</div>
      <div className="space-y-2">
        {player.email && (
          <div>
            <div className="text-xs text-crisp-gray mb-1">Email</div>
            <div className="value text-xs break-all">{player.email}</div>
          </div>
        )}
        {player.rank && (
          <div>
            <div className="text-xs text-crisp-gray mb-1">Rang</div>
            <div className="value">{player.rank}</div>
          </div>
        )}
        <div>
          <div className="text-xs text-crisp-gray mb-1">Dernière connexion</div>
          <div className="value text-xs">
            {new Date(player.lastSeen).toLocaleDateString('fr-FR', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            })}
          </div>
        </div>
        {player.registeredAt && (
          <div>
            <div className="text-xs text-crisp-gray mb-1">Inscription</div>
            <div className="value text-xs">
              {new Date(player.registeredAt).toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
